import clsx from 'clsx';
import { InputHTMLAttributes, memo, PropsWithChildren } from 'react';

type Props = PropsWithChildren<{
    onChange: () => void;
}>

export type RadioButtonProps = Props & InputHTMLAttributes<HTMLInputElement>

export const RadioButton = memo((
    {
        id,
        name,
        disabled,
        children,
        onChange,
        ...rest
    }: RadioButtonProps,
) => (
    <div className="vss-radio-button">
        <input
            {...rest}
            id={id}
            name={name}
            disabled={disabled}
            onChange={onChange}
            type="radio"
            className="vss-radio-button__input"
        />

        <label
            htmlFor={id}
            className={clsx({
                'vss-radio-button__label': true,
                'vss-radio-button__label--disabled': disabled,
            })}
        >
            <span className={clsx({
                'vss-radio-button__appearance': true,
                'vss-radio-button__appearance--disabled': disabled,
            })}
            />

            <p className={clsx({
                'vss-radio-button__label-text': true,
                'vss-radio-button__label-text--disabled': disabled,
            })}
            >
                {children}
            </p>
        </label>
    </div>
));
